import $ from 'jquery';
import View from 'view/base';
import Util from 'root/module/util';

const page_condition_options = [
    {
        label: 'URL exactly matches',
        value: 'exact_url_match',
        placeholder: 'e.g. https://www.example.com',
    },
    {
        label: 'URL contains',
        value: 'url_contains',
        placeholder: 'e.g. dashboard',
    },
    {
        label: 'URL does not contain',
        value: 'url_contains_not',
        placeholder: 'e.g. dashboard',
    },
    {
        label: 'URL start with',
        value: 'url_start',
        placeholder: 'e.g. https://www.example.com/dashboard',
    },
    {
        label: 'URL ends with',
        value: 'url_end',
        placeholder: 'e.g. /dashboard',

    },
    {
        label: 'URL is not',
        value: 'url_not',
        placeholder: 'e.g. https://www.example.com/dashboard',
    },
    {
        label: 'URL matches regex',
        value: 'url_regex',
        placeholder: 'e.g. ^https?://(www\\.)?example\\.com(/.*)?$',
    },
];

const default_page_condition = {
    operator: 'or',
    conditions: [],
}

export default View.extend({
    events: {
        'click .page-condition-add'                 : 'onPageConditionAdd',
        'change select[name="page_condition_type"]' : 'onPageConditionTypeChange',
        'input input[name="page_condition_value"]'  : 'onChange',
        'click .page-condition-delete'              : 'onDomainDelete',
        'click .condition-type li'                  : 'onConditionTypeChange',
    },
    dom_handlers: {
        onPageConditionAdd: function(e) {
           // Add a new page condition into the form
            if (this.$el.find('.url-match-type').length >= 10) {
                // if the page conditions are over the limit, do not allow to add more
                return;
            }

            var content = '';
            if (this.$el.find('.url-match-type').length > 0) {
                // if there are no conditions, add a default one
                content += this.renderDefaultPageCondition();
            }

            this.$el.find('.page-condition-add').before(content);

            // update add button if page conditions are over the limit
            if (this.$el.find('.url-match-type').length >= 10) {
                this.$el.find('.page-condition-add').prop('disabled', true);
            } else {
                this.$el.find('.page-condition-add').prop('disabled', false);
            }
        },
        onPageConditionTypeChange: function(e) {
            // change the placeholder based on the selected condition type
            const target = $(e.currentTarget);
            const selected_type = target.val();
            const placeholder = page_condition_options.find(item => item.value === selected_type)?.placeholder || '';
            target.closest('.url-match-type').find('input[name="page_condition_value"]').attr('placeholder', placeholder);
            // update the model with the new type
            this.update();
        },
        onChange: function(e) {
            this.update();
        },
        onDomainDelete: function(e) {
            // remove current dom
            const target = $(e.currentTarget);
            // check how many left
            if (this.$el.find('.url-match-type').length <= 1) {
                // clean up the name="page_condition_value"
                this.$el.find('input[name="page_condition_value"]').val('');
                this.update();
                return;
            }

            target.closest('.url-match-type').remove();

            this.update();

            // update add button if page conditions are over the limit
            if (this.$el.find('.url-match-type').length >= 10) {
                this.$el.find('.page-condition-add').prop('disabled', true);
            } else {
                this.$el.find('.page-condition-add').prop('disabled', false);
            }
        },
        onConditionTypeChange: function(e) {
            // change the operator based on the selected condition type
            const operator = $(e.currentTarget).data('val');
            this.$el.find('.condition-type button.dropdown-select').text(operator === 'and' ? 'All' : 'Any');
            this.$el.find('.condition-type li').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            // update the model with the new operator
            this.update();
        }
    },
    initialize: function(options) {
        this.page_condition = options.data || JSON.stringify(default_page_condition);
    },

    update: function() {
        this.trigger('change');
    },

    renderDefaultPageCondition: function() {
        var content =
        '<div class="url-match-type">' +
            '<button type="button" class="page-condition-delete text-icon"><i class="fa-solid fa-circle-minus"></i></button>' +
            '<select class="solid compact" name="page_condition_type">' +
                page_condition_options.map(item => '<option value="' + item.value + '">' + item.label + '</option>').join('') +
            '</select>' +
            '<input type="text" class="solid compact" name="page_condition_value" placeholder="' + page_condition_options[0].placeholder + '">' +
        '</div>';

        return content;
    },

    getData: function() {
        const page_conditions = {};
        page_conditions.operator = this.$el.find('.condition-type li.selected').data('val') || 'or';

        page_conditions.conditions = [];

        this.$el.find('.url-match-type').each((index, element) => {
            const type = $(element).find('select[name="page_condition_type"]').val();
            const value = $(element).find('input[name="page_condition_value"]').val();

            page_conditions.conditions.push({ type, value });
        });

        return JSON.stringify(page_conditions);
    },

    render: function() {
        let content = '';
        let page_conditions = this.page_condition;

        if (!page_conditions) {
            page_conditions = default_page_condition;
        } else {
            try {
                const parsed_page_conditions = JSON.parse(page_conditions);

                if (parsed_page_conditions && typeof parsed_page_conditions === 'object') {
                    page_conditions = parsed_page_conditions;
                } else {
                    page_conditions = default_page_condition;
                }
            } catch (e) {
                page_conditions = default_page_condition;
            }
        }

        const operator = page_conditions.operator || 'or';
        content += '<div class="margin-bottom-12 margin-top-12 margin-left-26">When ' +
            '<div class="condition-type button-dropdown button-dropdown-left" data-update="true" data-append="true">' +
                '<button type="button" class="dropdown-select">' + (operator === 'and' ? 'All' : 'Any') + '</button>' +
                '<div>' +
                    '<ul class="dropdown dropdown-select">' +
                        '<li data-val="and"' + (operator === 'and' ? ' class="selected"' : '') + '>All</li>' +
                        '<li data-val="or"' + (operator === 'or' ? ' class="selected"' : '') + '>Any</li>' +
                    '</ul>' +
                '</div>' +
            '</div>' +
        ' of the conditions match</div>';

        if (page_conditions.conditions && Array.isArray(page_conditions.conditions)) {
            page_conditions.conditions.forEach((condition) => {
                const selected_type = condition.type || '';
                const condition_value = condition.value || '';

                const placehoder = page_condition_options.find(item => item.value === selected_type)?.placeholder;

                content +=
                '<div class="url-match-type">' +
                    '<button type="button" class="page-condition-delete text-icon"><i class="fa-solid fa-circle-minus"></i></button>' +
                    '<select class="solid compact" name="page_condition_type">' +
                        page_condition_options.map((item) => {
                            const selected_attr = item.value === selected_type ? ' selected' : '';
                            return '<option value="' + Util.htmlEntities(item.value) + '" ' + selected_attr +'>' + Util.htmlEntities(item.label) + '</option>';
                        }).join('') +
                    '</select>' +
                    '<input type="text" class="solid compact" name="page_condition_value" placeholder="' + Util.htmlEntities(placehoder) + '" value="' + Util.htmlEntities(condition_value) + '">' +
                '</div>';
            });
        }

        // if there are no conditions, add a default one
        const conditions = Array.isArray(page_conditions?.conditions) ? page_conditions.conditions : [];

        if (conditions.length === 0) {
            content += this.renderDefaultPageCondition();
        }

        // Disable "add" button if conditions exceed limit
        const is_add_disabled = conditions.length >= 10;

        content +=
        '<button type="button" class="page-condition-add text-primary-small"' + (is_add_disabled ? ' disabled' : '') + '>' +
            '<i class="fa-solid fa-circle-plus margin-right-8"></i>Add page condition' +
        '</button>';

        this.$el.html(content);
        return this;
    },
});